import { render, staticRenderFns } from "./WPagination.vue?vue&type=template&id=13210baa&"
import script from "./WPagination.vue?vue&type=script&lang=ts&"
export * from "./WPagination.vue?vue&type=script&lang=ts&"
import style0 from "./WPagination.vue?vue&type=style&index=0&id=13210baa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports